<template>
  <tr @click="goToDetails" class="is-clickable">
    <td v-if="isBillSuspended">
      <bill-sla :slaDetail="bill.slaDetail" />
    </td>
    <td>
      <v-chip class="white--text text-uppercase" :color="chipColor" small>
        <span class="font-weight-bold">{{
          $t(`bills.statusLabels.${toLowerCase(billState)}`)
        }}</span>
      </v-chip>
      <div
        v-if="isSent && bill.submittedAt"
        class="font-weight-bold text-no-wrap caption mt-1"
      >
        {{ $t("bills.sentAt") }}&nbsp;{{
          bill.submittedAt | date(dateTimeFormat)
        }}
      </div>
      <div
        v-if="isResent && bill.submittedAt"
        class="font-weight-bold text-no-wrap caption mt-1"
      >
        {{ $t("bills.resentAt") }}&nbsp;{{
          bill.submittedAt | date(dateTimeFormat)
        }}
      </div>
      <div
        v-if="isAcceptedOrFurther && bill.acceptedAt"
        class="font-weight-bold text-no-wrap caption mt-1"
      >
        {{ $t("bills.acceptedAt") }}&nbsp;{{
          bill.acceptedAt | date(dateTimeFormat)
        }}
      </div>
    </td>
    <td class="font-weight-medium">
      <div>
        <span class="body-1 font-weight-bold">
          {{ bill.protocolCode || $t("notAvailable") }}
        </span>
        <span v-if="bill.protocolCode">
          <base-copy-button
            :copiedText="copiedText"
            :valueToCopy="bill.protocolCode"
          ></base-copy-button>
        </span>
      </div>
    </td>
    <td v-if="isBillSuspended" class="text-no-wrap font-weight-medium">
      <div class="font-weight-bold">
        {{ bill.sentBackAt | date(dateFormat) }}
        <br />
        {{ bill.sentBackAt | date(hourFormat) }}
      </div>
    </td>
    <td class="text-no-wrap font-weight-medium">
      <div class="font-weight-bold">
        {{ bill.updatedAt | date(dateFormat) }}
        <br />
        {{ bill.updatedAt | date(hourFormat) }}
      </div>
    </td>
    <td class="text-center font-weight-medium">
      {{ bill.numberOfServices || 0 }}
    </td>
    <td>
      <v-btn
        color="primary"
        class="caption font-weight-bold"
        rounded
        depressed
        small
        @click.stop="goToDetails"
        >{{ $t(openBillButtonLabel) }}
      </v-btn>
    </td>
  </tr>
</template>

<script>
import BillSla from "./BillSla";
import BaseCopyButton from "../BaseCopyButton";

export default {
  components: {
    BillSla,
    BaseCopyButton
  },
  props: {
    bill: {
      type: Object,
      required: true
    },
    isBillSuspended: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      copiedText: this.$t("billProtocolCodeCopied"),
      dateTimeFormat: `DD/MM/YYYY - ${this.$i18n.t("hour")} HH.mm`,
      dateFormat: "DD/MM/YYYY",
      hourFormat: "HH.mm"
    };
  },
  computed: {
    billId() {
      if (this.bill?.billId) {
        return this.bill.billId;
      }
      return null;
    },
    billType() {
      if (this.bill?.billType) {
        return this.bill.billType;
      }
      return null;
    },
    isBillTypeAnyKindOfVariation() {
      let bTypes = ["POSITIVEVARIATION", "ZEROVARIATION", "NEGATIVEVARIATION"];
      if (this.billType) {
        return bTypes.includes(this.billType);
      }
      return false;
    },
    billState() {
      if (this.bill?.billState) {
        return this.bill.billState;
      }
      return null;
    },
    isBillInReadonly() {
      return this.bill?.readonly;
    },
    chipColor() {
      switch (this.billState) {
        case "DRAFT":
          return "secondary";
        case "SENT":
          return "warning";
        case "CHECKING":
          return "warning";
        case "SENTBACK":
        case "CREDITNOTE":
          return "error";
        case "RESENT":
          return "warning";
        case "ACCEPTED":
        case "VERIFIED":
        case "UNVERIFIED":
        case "TOPAY":
        case "INPAYMENT":
        case "CROTOBECONFIRMED":
        case "PAID":
        case "CLOSED":
        case "CLOSEDXSANIMPRESA":
        case "CREDITNOTEPAID":
          return "success";
        case "UNPAID":
          return "success";
        default:
          return "";
      }
    },
    openBillButtonLabel() {
      if (this.isDraft || this.isSentback) {
        return "billEditButton";
      } else {
        return "detailsButton";
      }
    },
    isDraft() {
      return this.billState && this.billState === "DRAFT";
    },
    isSent() {
      return this.billState && this.billState === "SENT";
    },
    isResent() {
      return this.billState && this.billState === "RESENT";
    },
    isSentback() {
      return this.billState && this.billState === "SENTBACK";
    },
    isAcceptedOrFurther() {
      return this.billState?.includes(
        "ACCEPTED",
        "VERIFIED",
        "UNVERIFIED",
        "TOPAY",
        "INPAYMENT",
        "CROTOBECONFIRMED",
        "PAID",
        "CLOSED",
        "CLOSEDXSANIMPRESA",
        "UNPAID",
        "CREDITNOTE",
        "CREDITNOTEPAID"
      );
    }
  },
  methods: {
    toLowerCase(value) {
      if (!value) return "";
      value = value.toString();
      return value.toLowerCase();
    },
    goToDetails() {
      if (this.billId) {
        this.goToBill(this.billId);
      }
    },
    goToBill(bId) {
      this.$store.commit("bills/SET_ACTIVE_BILL_ID", bId);
      this.$router.push({
        name: "_billDetails",
        params: { id: bId }
      });
    }
  }
};
</script>

<style scoped></style>
